//#region src/resources/agent-configuration/ShouldMockAgentConfiguration.ts
var e = (e, t) => t === !1 ? !1 : t === !0 || e === "lbergeronsfdevt1z2624x";
//#endregion
export { e as shouldMockAgentConfiguration };

//# sourceMappingURL=ShouldMockAgentConfiguration.js.map